$(document).ready(function () {
    $(document).on('click', '.initiate-checkout_js, .initiate-checkout_js-remembered-guest-user', function () {
        if ($('#siteName').val() === 'pvhckca') {
            if ($(this).hasClass('disabled')) {
                $('.buttonErrorMessage').removeClass('d-none');
                return false;
            }
            $.spinner().start();
            var $this = $(this);
            var cartPageUrl = $this.data('cartpage');
            var url = $this.data('href');
            var rememberedGuestUser = $(this).hasClass('initiate-checkout_js-remembered-guest-user');
            if (rememberedGuestUser) {
                url = url + '?proceedrememberedGuestUser=true';
            }
            $.ajax({
                url: url,
                type: 'GET',
                global: false,
                success: function (data) {
                    $.spinner().stop();
                    if ((data && data.proceedToCheckout === true)) {
                        $('.btnCheckout').trigger('click');
                        $.spinner().start();
                    } else {
                        $this.data('lastclicked', true);
                        var redirectURL = data.redirectUrl ? data.redirectUrl : cartPageUrl
                        window.location.href = redirectURL;
                    }
                },
                error: function () {
                    $('.btnCheckout').trigger('click');
                }
            });
        }
    });
});
